import style from './ModalSelectSample.module.css';

import { observer } from 'mobx-react-lite';
import Modal from 'ui/Modal';
import Table from 'widgets/Table';
import { useEffect, useRef, useState } from 'react';
import { getSamplesV2 } from 'services/sample.services';
import TextField from 'ui/TextField';
import SelectPathStorage from 'widgets/SelectPathStorage';
import ExpandSample from './ExpandSample';
import ExpandedRow from 'widgets/Table/ExpandedRow';
import { TABLE_SAMPLE_COLUMN } from 'consts/project.const';

const ModalSelectSample = observer(({ open, onClose, submit, sampleType }) => {
  const tableRef = useRef(null);

  const [samples, setSamples] = useState([]);
  const [node, setNode] = useState(null);
  const [barcode, setBarcode] = useState(null);

  const [pagination, setPagination] = useState({
    itemsCount: 0,
    limit: 0,
    page: 1,
    pagesCount: 1,
  });
  const [columns] = useState(TABLE_SAMPLE_COLUMN);

  useEffect(() => {
    onTableUpdate();
  }, [node, barcode]);

  const getSamples = async (options) => {
    const response = await getSamplesV2(options);
    setSamples(response.data);
    setPagination({
      page: response?.pagination?.page,
      pagesCount: response?.pagination?.pages_count,
      itemsCount: response?.pagination?.items_count,
      limit: response?.pagination?.limit,
    });
  };

  const onTableUpdate = async (options) => {
    await getSamples({
      ...options,
      id_type: sampleType?.id,
      is_virtual: false,
      status: 'packed',
      ...(barcode ? { barcode_value: barcode } : {}),
      ...(node?.entity === 'storage' ? { id_storage: node.id } : {}),
      ...(node?.entity === 'storage_pack' ? { id_pack: node.id } : {}),
    });
  };

  const handleSubmit = () => {
    const selectedIds = tableRef.current.getSelectedRows();
    submit(selectedIds);
    onClose();
  };

  return (
    <Modal
      title="Выбор внешнего объекта"
      submitText="Сохранить"
      onSubmit={handleSubmit}
      onClose={onClose}
      open={open}
    >
      <div className={style.modal}>
        <div
          style={{
            width: '100%',
          }}
        >
          <TextField
            label="Поиск по штрихкоду"
            className={style.infoItemValue}
            classNameLabel={style.labelInput}
            hideErrorBlock
            onChange={(e) => setBarcode(e)}
          />
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: '50px',
          }}
        >
          <div
            style={{
              width: '300px',
            }}
          >
            Расположение
          </div>
          <SelectPathStorage node={node} setNode={setNode} withoutPath={true} />
        </div>

        <Table
          initialColumns={columns}
          initialRows={samples}
          totalItems={pagination.itemsCount}
          itemsPerPage={pagination.limit}
          page={pagination.page}
          ref={tableRef}
          onUpdate={onTableUpdate}
          showToolbar={false}
          isSelectable
          isExpandable
          selectedValues={['id', 'barcode_value', 'locations', 'volume']}
        >
          <ExpandedRow rowExpandedPrepared={(row) => <ExpandSample row={row} />} />
        </Table>
      </div>
    </Modal>
  );
});

export default ModalSelectSample;
